import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";

const StepperTabs = ({ activeStep, steps: stepsProp }) => {
  const { t, i18n } = useTranslation("pricelist-modal");

  const steps =
    stepsProp ?? [t("steps.step_1"), t("steps.step_2"), t("steps.step_3")];
  const containerRef = useRef(null);
  const activeStepRef = useRef(null);

  //   const container = containerRef.current;
  //   const activeStepEl = activeStepRef.current;

  //   if (container && activeStepEl) {
  //     const scrollLeft =
  //       activeStepEl.offsetLeft -
  //       container.offsetWidth / 2 +
  //       activeStepEl.offsetWidth / 2;

  //     // Only scroll if not at first or last
  //     if (activeStep > 0 && activeStep < steps.length - 1) {
  //       container.scrollTo({
  //         left: scrollLeft,
  //         behavior: "smooth",
  //       });
  //     } else if (activeStep === 0) {
  //       container.scrollTo({ left: 0, behavior: "smooth" });
  //     } else if (activeStep === steps.length - 1) {
  //       container.scrollTo({ left: container.scrollWidth, behavior: "smooth" });
  //     }
  //   }
  // }, [activeStep, steps.length]);
  useEffect(() => {
    const activeEl = activeStepRef.current;
    const container = containerRef.current;
    if (!activeEl || !container) return;

    const inlineOption =
      activeStep === 0
        ? "start"
        : activeStep === steps.length - 1
        ? "end"
        : "center";

    try {
      activeEl.scrollIntoView({
        behavior: "smooth",
        inline: inlineOption,
        block: "nearest",
      });
      return;
    } catch (err) {}

    const dir = getComputedStyle(container).direction;
    console.log("dir", dir);
    const desired =
      activeEl.offsetLeft -
      container.offsetWidth / 2 +
      activeEl.offsetWidth / 2;

    if (dir === "rtl") {
      const max = container.scrollWidth - container.clientWidth;
      container.scrollTo({
        left: Math.max(0, Math.min(max, max - desired)),
        behavior: "smooth",
      });
    } else {
      container.scrollTo({ left: Math.max(0, desired), behavior: "smooth" });
    }
  }, [activeStep, steps.length, i18n.language]);
  return (
    <Box
      ref={containerRef}
      dir="auto"
      sx={{
        display: "flex",
        overflowX: { xs: "auto", md: "visible" },
        whiteSpace: "nowrap",
        width: "100%",
        gap: 2,
        justifyContent: { xs: "flex-start", md: "center" },
        scrollBehavior: "smooth",
        px: 1,
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {steps.map((label, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;

        return (
          <Box
            key={index}
            ref={isActive ? activeStepRef : null}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
              minWidth: "max-content",
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor:
                  isActive || isCompleted ? "#E8F5F1" : "#F2F3FB",
                color: isActive || isCompleted ? "#257C6D" : "#5A5A5A",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              {isCompleted ? <CheckIcon sx={{ fontSize: 13 }} /> : index + 1}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                // Active step stays green; once completed the label returns to
                // the standard dark text, and upcoming steps stay grey.
                color: isActive
                  ? "#257C6D"
                  : isCompleted
                  ? "rgba(62, 63, 76, 1)"
                  : "#5A5A5A",
                fontWeight: "500",
              }}
            >
              {label}
            </Typography>
            {index < steps.length - 1 && (
              <Typography sx={{ color: "#5A5A5A" }}>›</Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default StepperTabs;
